import React from 'react';
import cn from 'classnames';

import styles from '../../styles/form.css';
import { useOverflowCheck } from '../../hooks/overflow-hook';
import { Textarea } from '../textarea';
import { Rating } from '../rating';

import type { TFeedbackFormDumb } from './models';

export const FeedbackFormDumb = (props: TFeedbackFormDumb) => {
    const { Button, Text, form, isMobile, question, rating, topText, withRatingTextHelp } = props;
    const { commentValue, onChangeComment, onChangeRate, onSubmit, rateValue } = form;

    const textareaAnimation = cn(styles.textareaAnimation, {
        [styles.closed]: !(rateValue ?? false),
    });
    const [ref, isOverflowed] = useOverflowCheck();
    const shadowedButton = cn(styles.buttonSpace, {
        [styles.shadowedButton]: isOverflowed && isMobile,
        [styles.buttonSpaceDesktop]: !isMobile,
    });
    const formBody = cn(styles.formBody, {
        [styles.bodyPaddingDesktop]: !isMobile,
        [styles.bodyPaddingMobile]: isMobile,
    });

    return (
        <form className={styles.feedback} data-test-id="feedback-form-inputs" onSubmit={onSubmit}>
            <div ref={ref} className={formBody}>
                <Text className={styles.header} view={isMobile ? 'accent-primary-large' : 'xsmall'}>
                    {rating.questionText}
                </Text>
                <div className={styles.cuteText}>{topText}</div>
                <Rating
                    {...rating}
                    onChange={onChangeRate}
                    value={rateValue}
                    withHelpText={withRatingTextHelp}
                />

                <div className={textareaAnimation}>
                    <Textarea {...question} onChange={onChangeComment} value={commentValue} />
                </div>
            </div>
            {rateValue && (
                <div className={shadowedButton}>
                    <Button
                        block
                        borderRadius={8}
                        disabled={!commentValue?.trim() && !rateValue}
                        size="s"
                        type="submit"
                        view="primary"
                    >
                        Отправить
                    </Button>
                </div>
            )}
        </form>
    );
};
